import { userSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const emptyObject = {} as const;
const responseSchema = z.object({
  users: z.array(userSchema),
});

interface Params {
  includeProjects?: boolean;
}

export function useUsers({ includeProjects = false }: Params = emptyObject) {
  const url = `/users${objectToQueryParams({ includeProjects })}`;

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: queryKeys.getUsers(includeProjects),
    queryFn: () => get({ url, schema: responseSchema }),
  });

  return {
    users: data?.users || [],
    error,
    isLoading,
    isRefetching,
  };
}
